<template>
  <div id="GoTop" @click="GoTop()">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      isScrolling: false
    };
  },
  mounted() {
    window.addEventListener('wheel', this.handleUserScroll);
    window.addEventListener('touchmove', this.handleUserScroll);
  },
  beforeDestroy() {
    window.removeEventListener('wheel', this.handleUserScroll);
    window.removeEventListener('touchmove', this.handleUserScroll);
  },
  methods: {
    GoTop() {
      if (this.isScrolling) return;
      
      this.isScrolling = true;
      
      const smoothscroll = () => {
        if (!this.isScrolling) return;
        
        const currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        
        if (currentScroll > 0) {
          window.scrollTo(0, currentScroll - currentScroll / 10);
          requestAnimationFrame(smoothscroll);
        } else {
          this.isScrolling = false;
        }
      };
      
      smoothscroll();
    },
    
    handleUserScroll() {
      if (this.isScrolling) {
        this.isScrolling = false;
      }
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: block;
  width: 100%;
  height: 100%;
  color: rgb(8, 162, 233);
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue